import { useCallback } from 'react';
import Button from "@mui/material/Button";
import { useDispatch } from "react-redux";
import { alertSlice } from "src/store/alert/alert.slice";
import { useMutate } from "src/hooks/useFetch.hook";
import { paytmWebhookRefundUrl } from "src/react-query/endPoints";
import Token from "src/util/Token";

export const UpiRefundButton = ({ paymentId }) => {
  const dispatch = useDispatch();
  const { mutateAsync, isLoading } = useMutate('upiRefund');

  const onRefundClick = useCallback(async () => {
    const { actions: { setAlert } } = alertSlice;
    
    // Ensure bearer token is set before making the request
    Token.setAuthToken();
    
    try {
      await mutateAsync({
        url: paytmWebhookRefundUrl,
        method: 'POST',
        body: { 
          paymentId: paymentId
        }
      }, { 
        onSuccess: () => {
          dispatch(setAlert({
            open: true,
            message: "Refund request has been successfully processed",
            severity: "success",
          }));
          // Refresh the page after successful response
          window.location.reload();
        },
        onError: (error) => {
          // Extract error message from different possible sources in the response
          let errorMessage = "Failed to process refund request";
          
          if (error?.response?.data?.message) {
            errorMessage = error.response.data.message;
          } else if (error?.response?.data?.error) {
            errorMessage = error.response.data.error;
          } else if (typeof error?.response?.data === 'string') {
            errorMessage = error.response.data;
          } else if (error?.response?.data) {
            // Try to stringify if it's an object
            errorMessage = JSON.stringify(error.response.data);
          } else if (error?.message) {
            errorMessage = error.message;
          }
          
          dispatch(setAlert({
            open: true,
            message: errorMessage,
            severity: "error",
          }));
        }
      });
    } catch (error) {
      dispatch(setAlert({
        open: true,
        message: "An error occurred while processing the refund",
        severity: "error",
      }));
    }
  }, [paymentId, mutateAsync, dispatch]);

  return (
    <Button 
      variant="contained" 
      size="small"
      disabled={isLoading} 
      onClick={onRefundClick}
      sx={{
        minWidth: '80px',
        fontSize: '0.75rem',
        textTransform: 'none',
        backgroundColor: '#d32f2f',
        '&:hover': {
          backgroundColor: '#b71c1c',
        },
        '&:disabled': {
          backgroundColor: '#ffcdd2',
        }
      }}
    >
      {isLoading ? 'Processing...' : 'Refund'}
    </Button>
  );
};

